module.exports = __webpack_public_path__ + "media/8.a4c4b973.wav";